import { render, staticRenderFns } from "./imgBig.vue?vue&type=template&id=862a23a0&scoped=true&"
import script from "./imgBig.vue?vue&type=script&lang=js&"
export * from "./imgBig.vue?vue&type=script&lang=js&"
import style0 from "./imgBig.vue?vue&type=style&index=0&id=862a23a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862a23a0",
  null
  
)

export default component.exports